module.exports = __webpack_public_path__ + "static/img/qr.32fda89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/qr.jpg
// module id = TdcC
// module chunks = 21